import axios from 'axios';
import toast from 'react-hot-toast';

// Base URL from environment
const API_URL = import.meta.env.VITE_API_URL || 'https://api.racingmotorsmexico.com/api/app/v1';

// Create axios instance
const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add JWT token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jwt_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Don't set Content-Type for FormData, let browser set it with boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle errors globally
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status, data } = error.response;

      // Handle 401 Unauthorized - logout
      if (status === 401) {
        // Solo redirigir si no estamos ya en login (evitar loops)
        if (!window.location.pathname.includes('/login')) {
          localStorage.removeItem('jwt_token');
          localStorage.removeItem('user');
          window.location.href = '/login';
          toast.error('Sesión expirada. Por favor inicia sesión nuevamente.');
        }
        // Si estamos en login, NO mostrar el toast ni redirigir
        // Dejamos que el componente de login maneje el error
      }

      // Handle 403 Forbidden
      if (status === 403) {
        toast.error('No tienes permisos para realizar esta acción.');
      }

      // Handle 404
      if (status === 404) {
        toast.error('Recurso no encontrado.');
      }

      // Handle 500
      if (status >= 500) {
        //toast.error('Error del servidor. Intenta más tarde.');
      }

      // Show error message if available
      if (data?.message || data?.mensaje) {
        const message = data.message || data.mensaje;
        // No mostrar toast si estamos en la página de login (401 en login es esperado)
        // No mostrar toast para errores 409 (Conflict) - dejar que el componente los maneje
        const isLoginPage = status === 401 && window.location.pathname.includes('/login');
        const isConflictError = status === 409;
        if (!error.config.skipErrorToast && !isLoginPage && !isConflictError) {
          toast.error(message);
        }
      }
    } else if (error.request) {
      toast.error('Error de conexión. Verifica tu conexión a internet.');
    } else {
      toast.error('Ocurrió un error inesperado.');
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;

